export default __webpack_public_path__ + "59d6e480558c3395b3fab8edb8beb013.png";